export * from '@cipafacil/directives/scrollbar/scrollbar.directive';
export * from '@cipafacil/directives/scrollbar/scrollbar.module';
